
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"22","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6 9L0 0h7l6 9-6 9H0l6-9z","fill":"#8FEE9E"}}),_c('path',{attrs:{"d":"M15 9L9 0h7l6 9-6 9H9l6-9z","fill":"#38D17A"}})])
          )
        }
      }
    